// Central config — edit contact details and case studies here.
import { GALLERIES } from "./galleries";

export const CONTACT = {
  whatsapp: "523332509484", // 52 (MX) + 3332509484
  whatsappMessage: "Hola Juan Pablo, vi tu sitio y quiero agendar una llamada.",
  booking: "https://app.juanpablocortes.com.mx/widget/booking/RgiNmZJWavDxUMTkDrCE",
  email: "hola@juanpablocortes.com.mx",
};

export const whatsappLink = () =>
  `https://wa.me/${CONTACT.whatsapp}?text=${encodeURIComponent(CONTACT.whatsappMessage)}`;

export const SERVICES = [
  {
    id: "landing",
    n: "01",
    title: "Landing pages",
    solves: "Convierte tráfico de anuncios en llamadas y ventas.",
    who: "Para negocios que invierten en publicidad y necesitan cerrar leads.",
    delivers: "Página enfocada en un objetivo, copy de conversión y medición.",
  },
  {
    id: "site",
    n: "02",
    title: "Sitios web",
    solves: "Presencia profesional que da confianza y posiciona tu marca.",
    who: "Para empresas que quieren verse serias y ordenar su mensaje.",
    delivers: "Sitio multi-sección, veloz, editable y listo para SEO.",
  },
  {
    id: "ecommerce",
    n: "03",
    title: "Tiendas en línea",
    solves: "Vende directo al público con una tienda que convierte.",
    who: "Para marcas y productos que venden a consumidor final.",
    delivers: "Tienda en Shopify o a medida: catálogo, carrito y pagos.",
  },
  {
    id: "b2b",
    n: "04",
    title: "Tiendas B2B",
    solves: "Digitaliza tu catálogo y pedidos mayoristas sin fricción.",
    who: "Para distribuidores y fabricantes que venden a otros negocios.",
    delivers: "Catálogo, listas de precios por cliente y flujo de pedido.",
  },
  {
    id: "app",
    n: "05",
    title: "Apps web a la medida",
    solves: "Automatiza operación y procesos que hoy te frenan.",
    who: "Para operaciones que necesitan software propio, no plantillas.",
    delivers: "Aplicación a medida con paneles, roles y lógica de negocio.",
  },
];

export const CASES = [
  {
    id: "inmopages",
    name: "Inmopages",
    type: "app",
    typeLabel: "App web / SaaS",
    sector: "Inmobiliario",
    url: "https://inmopages.app",
    problem: "Agentes sin una forma rápida de publicar propiedades y captar leads.",
    solution: "Plataforma SaaS con login, dashboard, tracking y landings de propiedad en minutos.",
    image: "/cases/inmopages_1.jpg",
    proofImage: "/cases/inmopages_proof.jpg",
    gallery: [{ src: "/cases/inmopages_1.jpg", mobile: false }, ...GALLERIES.inmopages],
  },
  {
    id: "concrecadi",
    name: "Concrecadi",
    type: "b2b",
    typeLabel: "Tienda B2B",
    sector: "Construcción",
    url: "https://concrecadi.com",
    problem: "Venta de sellador con precio público y condiciones especiales para mayoristas, sin canal digital.",
    solution: "Tienda con catálogo, carrito, pago seguro, portal de mayoristas y recoger en tienda.",
    image: "/cases/concrecadi_1.jpg",
    proofImage: "/cases/concrecadi_proof.jpg",
    gallery: [{ src: "/cases/concrecadi_1.jpg", mobile: false }, ...GALLERIES.concrecadi],
  },
  {
    id: "cuencaluna",
    name: "Cuencaluna Tapalpa",
    type: "landing",
    typeLabel: "Landing page",
    sector: "Desarrollo inmobiliario",
    url: "https://cuencalunatapalpa.com",
    problem: "Desarrollo de terrenos sin un canal directo para agendar visitas y mostrar valor.",
    solution: "Landing editorial inmersiva con datos clave, agenda de visita y contacto por WhatsApp.",
    image: "/cases/cuencaluna_1.jpg",
    proofImage: "/cases/cuencaluna_proof.jpg",
    gallery: [{ src: "/cases/cuencaluna_1.jpg", mobile: false }, ...GALLERIES.cuencaluna],
  },
  {
    id: "maesi",
    name: "Maesi Soluciones Industriales",
    type: "site",
    typeLabel: "Sitio web",
    sector: "Industrial / maquinaria",
    url: "https://maesisolucionesindustriales.com",
    problem: "Más de 25 años fabricando maquinaria, pero sin un sitio que mostrara su catálogo y capacidad.",
    solution: "Sitio web completo: catálogo de equipos con buscador y filtros, servicios, nosotros y cotización.",
    image: "/cases/maesi_1.jpg",
    proofImage: "/cases/maesi_proof.jpg",
    gallery: [{ src: "/cases/maesi_1.jpg", mobile: false }, ...GALLERIES.maesi],
  },
  {
    id: "impresos",
    name: "Impresos Gráficos de Calidad",
    type: "landing",
    typeLabel: "Landing page",
    sector: "Imprenta",
    url: "https://impresosgraficosdecalidad.com",
    problem: "28 años de trayectoria sin un canal digital que captara clientes de impresión.",
    solution: "Landing enfocada: productos clave, proceso, prueba social y cotización directa por WhatsApp.",
    image: "/cases/impresos_1.jpg",
    gallery: [{ src: "/cases/impresos_1.jpg", mobile: false }, ...GALLERIES.impresos],
  },
  {
    id: "limpio",
    name: "Limpio Express",
    type: "app",
    typeLabel: "App web a medida",
    sector: "Servicios de limpieza",
    url: "https://limpioexpress.com",
    problem: "Control de limpieza y cumplimiento gestionado en papel, sin visibilidad por sucursal.",
    solution: "App con check por QR, dashboard de cumplimiento, incidencias, clientes y sucursales.",
    image: "/cases/limpio_1.jpg",
    gallery: [{ src: "/cases/limpio_1.jpg", mobile: false }, ...GALLERIES.limpio],
  },
  {
    id: "silikprotek",
    name: "Silik Prötek",
    type: "ecommerce",
    typeLabel: "Tienda en línea",
    sector: "Impermeabilizantes",
    url: "https://silikprotek.com",
    problem: "Producto con tecnología alemana sin un canal de venta directa que comunicara su valor.",
    solution: "Tienda en línea (Shopify) con oferta clara, comparativa antes/después, presentaciones y carrito.",
    image: "/cases/silik_1.jpg",
    gallery: [{ src: "/cases/silik_1.jpg", mobile: false }, ...GALLERIES.silikprotek],
  },
];

export const CASE_FILTERS = [
  { id: "all", label: "Todos" },
  { id: "landing", label: "Landing pages" },
  { id: "site", label: "Sitios web" },
  { id: "ecommerce", label: "Tienda en línea" },
  { id: "b2b", label: "Tiendas B2B" },
  { id: "app", label: "Apps web" },
];

export const FAQS = [
  {
    q: "¿Cuánto tarda un proyecto?",
    a: "Una landing enfocada puede estar lista en días. Sitios, tiendas en línea y tiendas B2B suelen ir de 1 a 3 semanas, y las apps a medida se definen por alcance en el diagnóstico.",
  },
  {
    q: "¿Qué incluye el trabajo?",
    a: "Estrategia de conversión, diseño, desarrollo, dominio y despliegue, medición básica y una ronda de iteración tras la entrega.",
  },
  {
    q: "¿Qué no incluye?",
    a: "No incluye pauta publicitaria, producción de foto/video profesional ni gestión de redes. Puedo recomendarte con quién complementarlo.",
  },
  {
    q: "¿Cómo cotizas proyectos a medida?",
    a: "Empezamos con una llamada de diagnóstico. Con el alcance claro, te envío una propuesta cerrada. Proyectos pequeños arrancan desde $499 USD; los mayores se cotizan a medida.",
  },
  {
    q: "¿Dónde trabajas?",
    a: "Trabajo con negocios de México y del mercado hispano/latino en EUA, 100% en remoto y con comunicación directa.",
  },
];

export const PROCESS = [
  { n: "01", title: "Llamada", desc: "Entendemos tu negocio, objetivo y contexto real." },
  { n: "02", title: "Diagnóstico", desc: "Definimos el problema a resolver y el alcance correcto." },
  { n: "03", title: "Propuesta", desc: "Recibes una propuesta cerrada: entregables, tiempo y precio." },
  { n: "04", title: "Desarrollo", desc: "Ejecución veloz con IA como acelerador interno." },
  { n: "05", title: "Entrega / iteración", desc: "Publicamos, medimos y ajustamos sobre resultados." },
];
